export enum OntarioLocationCheckStatus {
  Idle,
  InProgress,
  Done,
  Retry,
  BrowserPermission,
  Error,
}
